export default __webpack_public_path__ + "static/bgpicaro-696ef9fe590787713fd8d407d5dc2892.mp4";